// import React from 'react';
import React, { useEffect, useRef, useState } from 'react';
import Typewriter from 'typewriter-effect/dist/core';
import Button from '../../components/Button';
import Marque_Alsace from '../../ressources/images/Logo_marque-alsace.png'
import EMS_Logo from '../../ressources/images/EMS_Logo.png'
import SEVE_2025 from '../../ressources/images/SEVE.svg'
import AlsaceDigitale from '../../ressources/images/AlsaceDigitale.svg'
import LogoSemia from '../../ressources/images/Logo_semia.svg'
import TangoScan from '../../ressources/images/TangoScan.svg'
import LogoWeewio from '../../ressources/images/Logo_weewio.svg'
import LogoCNA from '../../ressources/images/Logo_cna.jpg'
import LogoAlkacon from '../../ressources/images/alkacon-logo.svg'
import LogoOpenCMS from '../../ressources/images/Logo_opencms.svg'
import FrenchTech from '../../ressources/images/french_tech.png'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import i18n from "../../I18next/i18n";
import { useTranslation } from 'react-i18next';


export default function EcosystemePartenariats() {
    const { t } = useTranslation();
    const titleRef = useRef(null);

    useEffect(() => {
        // Simulation de l'effet typewriter pour le titre
        const title = titleRef.current;
        const typewriter = new Typewriter(title, {
            loop: true
        });
        typewriter.typeString(t("eco_typewriter"))
            .deleteAll()
            .pauseFor(1500)
            .deleteAll()
            .start();
    }, [t]);

    return (
        <div className="overflow-x-hidden">
            {/* Header section */}
            <div className="landing-img flex items-center justify-center pt-16 max-h-52 bg-gradient-to-r from-blue-900 to-purple-900">
                <h1 className="landing-title text-4xl font-bold text-white" ref={titleRef}>
                    Nos Partenariats
                </h1>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 py-16">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-gray-800 mb-4">
                        {t("eco_titre_principal")}
                    </h2>
                    <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
                </div>

                {/* Bloc French Tech */}
                <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8">
                        <div className="flex items-center justify-center order-2 md:order-1">
                            <a target="_blank" rel="noopener noreferrer" href="https://lafrenchtechest.fr/">
                                <img
                                    src={FrenchTech}
                                    alt="French Tech"
                                    className="w-full max-w-[545px] mx-auto block"
                                />
                            </a>
                        </div>

                        <div className="p-8 order-1 md:order-2">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                            d="M12 3a6 6 0 00-3.6 10.8c.38.29.6.74.6 1.22V16a1 1 0 001 1h4a1 1 0 001-1v-.98c0-.48.22-.93.6-1.22A6 6 0 0012 3zm-2 15h4m-3 3h2" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800">French Tech</h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                                {t("eco_french_tech_text1")}
                            </p>
                        </div>
                    </div>
                </div>


                {/* Bloc SEVE */}
                <div className="mb-16 bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8">
                        <div className="p-8">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h3M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800">{t("eco_SEVE2025")}</h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed text-justify">
                                {t("eco_seve_text")}

                            </p>
                        </div>
                        <div className="grid md:grid-cols-2 gap-8 items-center ">
                            <div className="flex-wrap items-center justify-center object-contain">
                                <a target="_blank" rel="noopener noreferrer" href='https://www.strasbourg.eu/seve'  >
                                    <img
                                        src={SEVE_2025}
                                        alt="SEVE 2025"
                                        className="w-full max-w-[545px]"
                                    />
                                </a>
                            </div>
                            <div className="flex-wrap items-center justify-center object-contain">
                                <a target="_blank" rel="noopener noreferrer" href='https://www.strasbourg.eu'>
                                    <img
                                        src={EMS_Logo}
                                        alt="Logo Eurométropole de Strasbourg"
                                        className="w-full max-w-[545px]"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bloc Alsace Digitale & Semia */}
                <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8">
                        <div className="flex items-center justify-center order-2 md:order-1">
                            <div className="grid md:grid-cols-2 gap-8 items-center">
                                <div className="flex-wrap items-center justify-center object-contain">
                                    <a target="_blank" rel="noopener noreferrer" href='https://www.alsacedigitale.org/'>
                                        <img
                                            src={AlsaceDigitale}
                                            alt="Alsace Digitale"
                                            className="w-full max-w-[545px]"
                                        />
                                    </a>
                                </div>
                                <div className="flex-wrap items-center justify-center object-contain">
                                    <a target="_blank" rel="noopener noreferrer" href='https://www.startup-semia.com/'>
                                        <img
                                            src={LogoSemia}
                                            alt="Logo Eurométropole de Strasbourg"
                                            className="w-full max-w-[545px]"
                                        />
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="p-8 order-1 md:order-2">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800">Alsace Digitale & SEMIA</h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                                {t("eco_ad_semia_text1")}
                            </p>
                            <p className="text-gray-600 leading-relaxed text-justify">
                                {t("eco_ad_semia_text2")}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Bloc Weewio */}
                <div className="mb-16 bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8" >
                        <div className="grid md:grid-rows-2 gap-8 items-center p-8">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800">{t("eco_tango_weewio")}</h3>
                            </div>
                            <p>
                                {t("eco_tango_weewio_text1")}
                            </p>
                            <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded ">
                                <p className="text-gray-700 italic">
                                    {t("eco_tango_weewio_text2")}
                                </p>
                            </div>
                        </div>


                        <div className="grid md:grid-cols-2 gap-8 items-center ">

                            <div className="flex-wrap items-center justify-center object-contain">
                                <a target="_blank" rel="noopener noreferrer" href='https://www.weewio.com/'>
                                    <img
                                        src={LogoWeewio}
                                        alt="Logo Weewio"
                                        className="w-full max-w-[545px]"
                                    />
                                </a>
                            </div>
                            <div className="flex-wrap items-center justify-center object-contain">
                                <a target="_blank" rel="noopener noreferrer" href='https://www.strasbourg.eu/tango-scan'>
                                    <img
                                        src={TangoScan}
                                        alt="Logo Tango & Scan"
                                        className="w-full max-w-[545px]"
                                    />
                                </a>
                            </div>

                        </div>
                    </div>


                </div>


                {/* Bloc Marque Alsace */}
                <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8">
                        <div className="flex items-center justify-center order-2 md:order-1">
                            <div className="gap-8 items-center">

                                <div className="flex-wrap items-center justify-center object-contain">
                                    <a target="_blank" rel="noopener noreferrer" href='https://www.adira.com/marque-alsace/'>
                                        <img
                                            src={Marque_Alsace}
                                            alt="Logo Marque Alsace"
                                            className="w-full max-w-[545px]"
                                        />
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="p-8 order-1 md:order-2">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800"> {t("eco_marque_alsace")}</h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                                {t("eco_marque_alsace_text")}
                            </p>

                        </div>
                    </div>
                </div>


                {/* Bloc Calypso */}
                <div className="mb-16 bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8">
                        <div className="p-8">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800">{t("eco_cna")}</h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed text-justify">
                                {t("eco_cna_text")}

                            </p>
                        </div>
                        <div className="flex-wrap items-center justify-center object-contain">
                            <a target="_blank" rel="noopener noreferrer" href='https://calypsonet.org/'>
                                <img
                                    src={LogoCNA}
                                    alt="SEVE 2025"
                                    className="w-full max-w-[545px]"
                                />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bloc OpenCMS */}
                <div className="mb-16 bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="grid md:grid-cols-2 gap-8 items-center p-8">
                        <div className="flex items-center justify-center order-2 md:order-1">
                            <div className="grid md:grid-cols-2 gap-8 items-center">
                                <div className="flex-wrap items-center justify-center object-contain">
                                    <a target="_blank" rel="noopener noreferrer" href='https://www.alkacon.com'>
                                        <img
                                            src={LogoAlkacon}
                                            alt="Alkacon Software"
                                            className="w-full max-w-[545px]"
                                        />
                                    </a>
                                </div>
                                <div className="flex-wrap items-center justify-center object-contain">

                                    <a target="_blank" rel="noopener noreferrer" href='https://www.opencms.org'>


                                        <img
                                            src={LogoOpenCMS}
                                            alt="Logo OpenCMS"
                                            className="w-full max-w-[545px]"
                                        />
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="p-8 order-1 md:order-2">
                            <div className="flex items-center mb-4">
                                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mr-4">
                                    <svg className="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-gray-800">{t("eco_alkacon_opencms")}</h3>
                            </div>
                            <p className="text-gray-600 leading-relaxed text-justify">
                                {t("eco_alkacon_opencms_text")}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Section conclusion */}
                <div className="text-center bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl p-12">
                    <h3 className="text-2xl font-bold mb-4">{t("eco_engagement")}</h3>
                    <p className="text-lg opacity-90 max-w-3xl mx-auto">
                        {t("eco_engagement_text")}
                    </p>
                </div>
            </div>
        </div>
    );
}